import {
	BLUME_BRAND_PRIMARY_COLOR,
	BLUME_QUARTERARY_COLOR,
	BLUME_SECONDARY_COLOR,
	BLUME_TEXT_PLACEHOLDER_COLOR,
} from '../../consts/styles';

export const SHARE_VIA_EMAIL_PLACEHOLDER = 'johndoe@gmail.com';

export const SHARE_TIMEOUT = 5000;

export const validateEmail = email => {
	const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return re.test(email);
};

export const BLUME_SHARE_STUDY_CONTENT_STYLES = {
	CONTENT: isTablet => ({
		boxSizing: 'border-box',
		padding: isTablet ? 0 : '16px 24px 12px',
		display: 'flex',
		flexDirection: 'column',
		gap: '32px',
		overflowY: 'auto',
		flex: 1,
		marginTop: isTablet ? '20px' : 0,
	}),
	SHARE_SECTION: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	SHARE_SECTION_ITEM: {
		display: 'flex',
		flexDirection: 'column',
		gap: '6px',
	},
	SHARE_VIA_EMAIL: isTablet => ({
		display: 'grid',
		gridTemplateColumns: isTablet ? '1fr' : 'auto 60px',
		gap: '12px',
	}),
	EMAIL_INPUT: {
		height: '40px',
		borderRadius: '8px',
		'&:focus-within .hide-on-focus': {
			display: 'none',
		},
		'& .MuiInputBase-input': {
			padding: '0 !important',
		},
		'& .MuiInputBase-input::placeholder': {
			color: BLUME_TEXT_PLACEHOLDER_COLOR,
		},
	},
	INPUT_ICON: {
		color: BLUME_QUARTERARY_COLOR,
		width: '20px',
		height: '20px',
	},
	PAPER: {
		marginTop: '8px',
		boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
		borderRadius: '6px',
	},
	ERROR_TEXT: {
		color: 'rgba(217, 45, 32, 1)',
		fontSize: '12px',
		fontWeight: 400,
	},
	SEND_BUTTON: {
		height: '40px',
		borderRadius: '8px',
		textTransform: 'none',
		fontSize: 14,
		fontWeight: 600,
		color: 'rgba(255, 255, 255, 1)',
		boxShadow: 'none',
		whiteSpace: 'nowrap',
		background: 'rgba(66, 165, 245, 1)',
		color: 'rgba(255, 255, 255, 1)',
		'&.MuiButton-containedSizeMedium:hover': {
			backgroundColor: '#4096DC',
		},
	},
	COPY_LINK_BUTTON: {
		height: '40px',
		borderRadius: '8px',
		textTransform: 'none',
		fontSize: 14,
		fontWeight: 600,
		width: '100%',
		boxShadow: 'none',
		color: BLUME_BRAND_PRIMARY_COLOR,
		backgroundColor: 'rgba(235, 245, 254, 1)',
		'&.MuiButton-containedSizeMedium:hover': {
			backgroundColor: 'rgba(235, 245, 254, 1)',
		},
	},
	SHARE_SECTION_LABEL: {
		fontWeight: 400,
		fontSize: '14px',
		color: BLUME_SECONDARY_COLOR,
		lineHeight: '20px',
	},
	ALERT: {
		color: 'rgba(5, 58, 101, 1)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		boxSizing: 'border-box',
		gap: '8px',
		border: '1px solid rgba(208, 213, 221, 1)',
		borderRadius: '4px',
		padding: '4px 8px',
	},
	ALERT_TEXT: {
		fontSize: '12px',
		fontWeight: 500,
	},
	ACCORDIONS: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2px',
	},
	ACCORDION: {
		boxShadow: 'none',
		padding: 0,
		margin: '0 !important',
		'&::before': {
			display: 'none',
		},
		'& .MuiAccordionDetails-root': {
			paddingTop: 0,
			paddingBottom: 0,
		},
	},
	ACCORDION_DETAILS: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
	},
	ACCORDION_SUMMARY: {
		'& .MuiAccordionSummary-content': {
			display: 'flex',
			alignItems: 'center',
			gap: '12px',
			margin: 0,
		},

		'& .MuiAccordionSummary-expandIconWrapper': {
			transition: 'transform 0.3s ease',
		},
		'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
			transform: 'rotate(90deg)',
		},
	},
	ACCORDION_ICON_BOX: {
		width: '36px',
		height: '36px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: '6px',
		backgroundColor: 'rgba(242, 244, 247, 1)',
	},
	ACCORDION_TITLE: {
		color: BLUME_SECONDARY_COLOR,
		fontSize: '16px',
		fontWeight: 500,
	},
	SNACKBAR: {
		top: '50% !important',
		left: '50% !important',
		transform: 'translate(-50%, -50%) !important',
	},
};
